/**
 * `stacked` : libellé au-dessus du champ (formulaires pleine page, modales).
 * `row` : libellé à gauche, champ compact — même gabarit que les lignes de lecture
 * (InfoRow), pour qu'un bloc passe en modification sans changer de forme.
 */
export type FieldLayout = "stacked" | "row";

/** Libellé, champ et message d'erreur, dans l'une ou l'autre disposition. */
export const FieldFrame = ({
  layout,
  label,
  required,
  htmlFor,
  error,
  children,
}: {
  layout: FieldLayout;
  label?: string;
  required?: boolean;
  htmlFor?: string;
  error?: string;
  children: React.ReactNode;
}) => {
  const labelContent = label && (
    <>
      {label} {required && <span className="text-red-500">*</span>}
    </>
  );
  const errorMessage = error && (
    <p className="mt-1 text-sm text-red-500">{error}</p>
  );

  if (layout === "row") {
    return (
      <div className="flex gap-4 py-1 text-sm">
        <label
          htmlFor={htmlFor}
          className="w-1/3 shrink-0 pt-1 text-grey-medium font-oxaniumMedium"
        >
          {labelContent}
        </label>
        <div className="flex-1 min-w-0">
          {children}
          {errorMessage}
        </div>
      </div>
    );
  }

  return (
    <div>
      {label && (
        <label htmlFor={htmlFor} className="block text-tertiary mb-2">
          {labelContent}
        </label>
      )}
      {children}
      {errorMessage}
    </div>
  );
};

/** Marges internes d'un champ selon la disposition. */
export const fieldPadding = (layout: FieldLayout, small = false) =>
  layout === "row" ? "px-2 py-1 text-sm" : small ? "px-4" : "px-4 py-2";
